export const environment = {
  production: false,
  dis_alert_timeout: 3000,
  socketUrl: "https://careernew.rapidise.co/backend",
  socketPath: "/myteksun/socket.io",
  loginUrl: "/projects/my_teksun/login",
  baseUrl: "https://careernew.rapidise.co/backend/api",
  bucketUrl: "https://s3.ap-south-1.amazonaws.com/my.teksun",
  clientId: "461219031009-itoopgbbblmou604loqd7mtkebube7rj.apps.googleusercontent.com",
  pmsUrl: "https://my.teksun.com/pms/",
};
